export default __webpack_public_path__ + "static/media/zonapro-bold.183cd820.otf";